import React from 'react';
import { Badge } from '../ui/Badge';

interface BuyerBadgeProps {
  isBuyer: boolean;
}

export function BuyerBadge({ isBuyer }: BuyerBadgeProps) {
  if (!isBuyer) return null;
  return (
    <Badge variant="green">
      Kaufinteressent
    </Badge>
  );
}
